const locale = require('./copyProposal.i18n.json');

/*@ngInject*/
const CopyProposalModalController = function ($rootScope, $scope, $state, $stateParams, submissionConstant, coreMediator, submissionId, proposalId, proposalActionsMediator, coreConstant) {

    const dynamicDataSetParams = {
            name: 'Proposal Quotes',
            submissionUri: `com.firstbest.underwriting.submission.Submission:${submissionId}`,
            ownerUri: `com.firstbest.underwriting.proposal.Proposal:${proposalId}`
        };

    $scope.i18n = locale;
    $scope.isOkayDisabled = false;

    function init() {
        coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then((result) => {

            $scope.proposalList = _.map(result, function (item) {
                item.selected = true;
                return item;
            });

            if ($scope.proposalList.length === 1) {
                $scope.onCopyProposal();
            }
        });
    }

    $scope.onSelectQuote = function (event, proposal) {
        var selectedQuoteList = _.filter($scope.proposalList, function (quote) {
            return quote.selected;
        });

        $scope.isOkayDisabled = _.isEmpty(selectedQuoteList);
    };

    $scope.onCopyProposal = function () {
        var quotes = _.filter($scope.proposalList, function (proposal) {
            return proposal.selected;
        });

        quotes = _.map(quotes, function (quote) {
            return quote.value;
        });

        $scope.$close({
            quotes: quotes
        });
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

    init();
};

angular.module('gw-um-submission')
    .controller('copyProposalModalController', CopyProposalModalController);
